const constants = {
  roles: {
    admin: 'b3be3c72-65f6-4aa5-b1f6-5c43cd9324a4',
    normal: '9fb4c0c5-ad6c-48ea-8137-cc1192c2138c'
  },
  status: {
    free: '0',
    booked: '1'
  },
  distributionTypes: {
    free: 0,
    day: 1,
    minutes: 2
  },
  menus: [
    {
      // icon: 'mdi-home',
      icon:'mdi-clipboard-check-multiple-outline',
      title: 'dashboard.title',
      rute: '/dashboard',
      admin: false
    },
    {
      icon: 'mdi-account-multiple',
      title: 'users.title',
      rute: '/users',
      admin: true
    },
    {
      icon: 'mdi-card-account-details',
      title: 'enterprises.title',
      rute: '/enterprises',
      admin: true
    },
    {
      icon: 'mdi-cellphone-cog',
      title: 'playerSettings.title',
      rute: '/players',
      admin: true
    },  
    // {
    //   icon: 'mdi-clipboard-check-multiple-outline',
    //   title: 'status.title',
    //   rute: '/status',
    //   admin: false
    // },
  ],
  daysOfWeek: [1, 2, 3, 4, 5, 6, 0]
}

export default constants
